import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-property-scene-mobile',
  templateUrl: './property-scene-mobile.component.html',
  styleUrls: ['./property-scene-mobile.component.scss'],
  standalone: false
})
export class PropertySceneMobileComponent {
  @Input()
  isIndicateurRisqueMoyenHaut = false;
}
